
export const createParamSelector = <S, A, T = unknown>(selector: (params: S) => A): (_state: T, params: S) => A => {
  return (_, params) => selector(params);
};

export const getUseQueryResultData = <T,>(result: { data?: T}) : T | undefined => result.data
